import React from 'react';

const container = {
  display: 'flex',
  justifyContent: 'center',
};

const image = {
  width: 288 * .32,
  height: 60 * .32,
};

const Divider = () => (
  <div style={container}>
    <img src={require('assets/images/misc/divider.png')} alt="" style={image} />
  </div>
);

export default Divider;